function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

if (!customElements.get("filter-toggle")) {
  class FacetFiltersToggle extends HTMLElement {
    constructor() {
      super();

      this.facetSidebar = document.querySelector(".facets-wrapper");

      this.init();
    }

    onToggle() {
      if (this.classList.contains("on")) {
        this.classList.remove("on");

        if (this.facetSidebar) {
          this.facetSidebar.classList.add("hide");
          document.body.classList.remove("overflow-hidden-mobile");
        }
      } else {
        this.classList.add("on");

        if (this.facetSidebar) {
          this.facetSidebar.classList.remove("hide");
          document.body.classList.add("overflow-hidden-mobile");
        }
      }
    }

    init() {
      this.addEventListener("click", function () {
        this.onToggle();
      });

      if (
        parseInt(window.innerWidth) <= 1024 &&
        this.classList.contains("on")
      ) {
        this.onToggle();
      }

      this.facetSidebar.classList.add("active");
    }
  }

  customElements.define("filter-toggle", FacetFiltersToggle);
}

document
  .querySelectorAll(".facets-container .btn-close")
  .forEach(function (obj) {
    obj.addEventListener("click", function (e) {
      document.querySelector("filter-toggle").click();
    });
  });

if (!customElements.get("size-chart")) {
  class SizeChart extends HTMLElement {
    constructor() {
      super();

      this.triggerClose = this.querySelector(".btn-close");

      this.init();
    }

    openSizeChart() {
      this.classList.add("opened");
    }

    closeSizeChart() {
      this.classList.remove("opened");
    }

    init() {
      let sizechart = this;
      document.querySelectorAll("[href='#size-guide']").forEach(function (obj) {
        obj.addEventListener("click", function (e) {
          e.preventDefault();
          sizechart.openSizeChart();
        });
      });

      this.triggerClose.addEventListener("click", function (e) {
        sizechart.closeSizeChart();
      });
    }
  }

  customElements.define("size-chart", SizeChart);
}

// document.querySelectorAll('.light-toggle').forEach(function(obj) {
//   obj.addEventListener("click", function(e) {
//     if(obj.classList.contains("on")) {
//       obj.classList.remove("on");
//       obj.classList.add("off");
//       document.querySelector("body").classList.add("dark_mode");
//       setCookie("darkmode", 1, 1);
//       var url = window.location.href;
//       if(url.includes("?") && url.includes("lightmode")) {
//         var refresh = url.split("?")[0] + "?" + url.split("?")[1].replace("lightmode", '');
//         window.history.pushState({ path: refresh }, '', refresh);
//       }
//     }
//     else {
//       obj.classList.remove("off");
//       obj.classList.add("on");
//       document.querySelector("body").classList.remove("dark_mode");
//       setCookie("darkmode", 0, 1);
//       var url = window.location.href;
//       if(url.includes("?") && url.includes("darkmode")) {
//         var refresh = url.split("?")[0] + "?" + url.split("?")[1].replace("darkmode", '');
//         window.history.pushState({ path: refresh }, '', refresh);
//       }
//     }
//   });
// });

// var url = window.location.href;

// if (url.includes("?") && url.includes("darkmode")) {
//   setCookie("darkmode", 1, 1);
// }
// if (url.includes("?") && url.includes("lightmode")) {
//   setCookie("darkmode", 0, 1);
// }

// if(getCookie("darkmode")=='1' || document.querySelector("body").classList.contains("template-login") || document.querySelector("body").classList.contains("template-register")) {
//   document.querySelector("body").classList.add("dark_mode");
//   document.querySelector(".light-toggle").classList.add("off");
//   document.querySelector(".light-toggle").classList.remove("on");
// }
// else {
//   document.querySelector("body").classList.remove("dark_mode");
//   document.querySelector(".light-toggle").classList.add("on");
//   document.querySelector(".light-toggle").classList.remove("off");
// }

class Accordion {
  constructor(el) {
    // Store the <details> element
    this.el = el;
    // Store the <summary> element
    this.summary = el.querySelector("summary");
    // Store the <div class="content"> element
    this.content = el.querySelector(".accordion__content");

    // Store the animation object (so we can cancel it if needed)
    //this.animation = null;
    // Store if the element is closing
    this.isClosing = false;
    // Store if the element is expanding
    this.isExpanding = false;
    // Detect user clicks on the summary element
    this.summary.addEventListener("click", (e) => this.onClick(e));
  }

  onClick(e) {
    // Stop default behaviour from the browser
    e.preventDefault();
    // Add an overflow on the <details> to avoid content overflowing
    this.el.style.overflow = "hidden";
    // Check if the element is being closed or is already closed
    if (this.isClosing || !this.el.open) {
      document.querySelectorAll(".accordion details").forEach(function (obj1) {
        if (obj1.hasAttribute("open")) {
          obj1.querySelector("summary").dispatchEvent(new Event("click"));
        }
      });

      this.summary.classList.add("open");
      this.open();
      // Check if the element is being openned or is already open
    } else if (this.isExpanding || this.el.open) {
      this.summary.classList.remove("open");
      this.shrink();
    }
  }

  shrink() {
    // Set the element as "being closed"
    this.isClosing = true;

    // Store the current height of the element
    const startHeight = `${this.el.offsetHeight}px`;
    // Calculate the height of the summary
    const endHeight = `${this.summary.offsetHeight}px`;

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }

    // Start a WAAPI animation
    this.animation = this.el.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: "cubic-bezier(.784, .007, .222, .989)",
      }
    );

    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(false);
    // If the animation is cancelled, isClosing variable is set to false
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    // Apply a fixed height on the element
    this.el.style.height = `${this.el.offsetHeight}px`;
    // Force the [open] attribute on the details element
    this.el.open = true;
    // Wait for the next frame to call the expand function
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    // Set the element as "being expanding"
    this.isExpanding = true;
    // Get the current fixed height of the element
    const startHeight = `${this.el.offsetHeight}px`;
    // Calculate the open height of the element (summary height + content height)
    const endHeight = `${
      this.summary.offsetHeight + this.content.offsetHeight
    }px`;

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }

    // Start a WAAPI animation
    this.animation = this.el.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: "cubic-bezier(.784, .007, .222, .989)",
      }
    );
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(true);
    // If the animation is cancelled, isExpanding variable is set to false
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    // Set the open attribute based on the parameter
    this.el.open = open;
    // Clear the stored animation
    this.animation = null;
    // Reset isClosing & isExpanding
    this.isClosing = false;
    this.isExpanding = false;
    // Remove the overflow hidden and the fixed height
    this.el.style.height = this.el.style.overflow = "";
  }
}

document.querySelectorAll(".accordion details").forEach((el) => {
  new Accordion(el);
});

document.querySelectorAll("#mobileSearchTrigger").forEach(function (obj) {
  obj.addEventListener("click", function (e) {
    const search_modal = document.querySelector(".search-modal-mobile");

    search_modal.classList.add("open");
  });
});

document
  .querySelectorAll(".search-modal-mobile .modal__close-button")
  .forEach(function (obj) {
    obj.addEventListener("click", function (e) {
      obj.closest(".search-modal-mobile").classList.remove("open");
    });
  });

document.querySelectorAll("a[href]").forEach(function (obj) {
  obj.addEventListener("click", function (e) {
    var url = this.getAttribute("href");

    if (url.includes("www.veloklub.com") || url.includes("www.dstnc.com")) {
      e.preventDefault();
      if (getCookie("darkmode") == "1") {
        if (url.includes("?")) {
          url += "&darkmode";
        } else {
          url += "?darkmode";
        }
      } else {
        if (url.includes("?")) {
          url += "&lightmode";
        } else {
          url += "?lightmode";
        }
      }
      window.location.href = url;
    }
  });
});

if (document.querySelector("#CountryList")) {
  document
    .querySelector("#CountryList")
    .addEventListener("change", function (e) {
      this.closest(".shopify-localization-form").submit();
    });
}

/*
document.querySelectorAll(".slidein-row").forEach(function(obj) {
  var delay = obj.getAttribute("data-delay");
  
  setTimeout(function() {
  	obj.classList.add("loaded");
  }, delay);
});

document.querySelectorAll(".fadein_row").forEach(function(obj) {
  var delay = obj.getAttribute("data-delay");
  
  setTimeout(function() {
  	obj.classList.add("loaded");
  }, delay);
});

document.querySelectorAll(".expand-row").forEach(function(obj) {
  var delay = obj.getAttribute("data-delay");
  
  setTimeout(function() {
  	obj.classList.add("loaded");
  }, delay);
});
*/
document.querySelectorAll(".color_swatch").forEach(function (obj) {
  obj.onmouseover = function () {
    var color = obj.getAttribute("data-value");
    document.querySelectorAll(".current_color").forEach(function (obj1) {
      obj1.textContent = color;
    });
  };

  obj.onmouseout = function () {
    document.querySelectorAll(".current_color").forEach(function (obj1) {
      obj1.textContent = obj1.getAttribute("data-value");
    });
  };

  obj.addEventListener("click", function (e) {
    e.preventDefault();
    var size = "";
    var size_url = "";
    if (document.querySelector("input[name='Size']:checked")) {
      size = document.querySelector("input[name='Size']:checked").value;
      var size_url = "?size=" + size;
    }
    var url = obj.getAttribute("href");

    if (url) {
      // window.location.href = url + size_url;
    }
  });
});

var url = new URL(window.location.href);
var s = url.searchParams.get("size");
if (s) {
  var size_sel = document.querySelector(
    "input[name='Size'][value='" + s + "']"
  );

  if (size_sel) {
    size_sel.checked = true;
    console.log(document.querySelector("variant-radios"));

    if ("createEvent" in document) {
      var evt = document.createEvent("HTMLEvents");
      evt.initEvent("change", false, true);
      document.querySelector("variant-radios").dispatchEvent(evt);
    } else {
      document.querySelector("variant-radios").fireEvent("onchange");
    }
  }
}
var q = url.searchParams.get("q");
console.log("q", q);
if (q) {
  document.querySelector("body").classList.add("hasGender");
} else {
  document.querySelector("body").classList.remove("hasGender");
}

// document.querySelectorAll(".product-recommendations .controls button").forEach(function(obj) {
//   obj.addEventListener("click", function(e) {
//     var wrapper = this.closest(".product-recommendations").querySelector(".products-wrapper");
//     var step = wrapper.querySelector(".grid__item").offsetWidth;
//     if(obj.classList.contains("btn-prev")) {
//       wrapper.scrollLeft -= step;
//     }
//     else if(obj.classList.contains("btn-next")) {
//       wrapper.scrollLeft += step;
//     }
//   });
// });

document.addEventListener("click", function (e) {
  if (e.target.classList.contains("recommend_btn-prev")) {
    var wrapper = e.target
      .closest(".product-recommendations")
      .querySelector(".products-wrapper");
    var step = wrapper.querySelector(".grid__item").offsetWidth;

    if (wrapper.clientWidth >= 768) {
      step = step * 3;
    }

    //     wrapper.scrollLeft -= step;

    SmoothHorizontalScrolling(wrapper, 100, 0 - step, wrapper.scrollLeft);
  } else if (e.target.classList.contains("recommend_btn-next")) {
    var wrapper = e.target
      .closest(".product-recommendations")
      .querySelector(".products-wrapper");
    var step = wrapper.querySelector(".grid__item").offsetWidth;

    if (wrapper.clientWidth >= 768) {
      step = step * 3;
    }

    //     wrapper.scrollLeft += step;

    SmoothHorizontalScrolling(wrapper, 100, step, wrapper.scrollLeft);
  }
});

document
  .querySelectorAll(".product-recommendations .products-wrapper")
  .forEach(function (obj) {
    obj.addEventListener("scroll", function (e) {
      updateButtons(
        obj,
        obj.parentElement.querySelector(".btn-prev"),
        obj.parentElement.querySelector(".btn-next")
      );
    });
  });

function updateButtons(wrapper, prev, next) {
  var step = wrapper.querySelector(".grid__item").offsetWidth;
  var scrollwidth = wrapper.scrollWidth - wrapper.clientWidth;
  if (wrapper.scrollLeft < step / 2) {
    prev.classList.add("disabled");
  } else {
    prev.classList.remove("disabled");
  }

  if (wrapper.scrollLeft > scrollwidth - step / 2) {
    next.classList.add("disabled");
  } else {
    next.classList.remove("disabled");
  }
}

function SmoothHorizontalScrolling(e, time, amount, start) {
  var eAmt = amount / 100;
  var curTime = 0;
  var scrollCounter = 0;
  while (curTime <= time) {
    window.setTimeout(SHS_B, curTime, e, scrollCounter, eAmt, start);
    curTime += time / 100;
    scrollCounter++;
  }
}

function SHS_B(e, sc, eAmt, start) {
  e.scrollLeft = eAmt * sc + start;
}

var maxh = 0;
document.querySelectorAll(".tabs_navs .nav").forEach(function (obj) {
  var tab_panel = obj.closest(".product__tabs");
  var id = obj.getAttribute("data-for");
  var tab_content = tab_panel.querySelector(id);
  maxh = tab_content.offsetHeight > maxh ? tab_content.offsetHeight : maxh;
  console.log(maxh);
  tab_panel.querySelector(".tabs_panel").style.height = maxh + "px";
  obj.addEventListener("click", function (e) {
    e.preventDefault();
    tab_panel.querySelector(".tab_content.active").classList.remove("active");
    tab_content.classList.add("active");
    tab_panel
      .querySelector(".tabs_navs .nav.active")
      .classList.remove("active");
    this.classList.add("active");
  });
});

document.querySelectorAll(".header__icon--account").forEach(function (obj) {
  obj.addEventListener("click", function (e) {
    setCookie("login_redirect", window.location.href);
    localStorage.setItem("login_redirect", window.location.href);
  });
});

document
  .querySelectorAll(".header__icon--account.loggedin")
  .forEach(function (obj) {
    obj.addEventListener("click", function (e) {
      e.preventDefault();

      var menu = document.querySelector(".profile_popup");

      if (menu.classList.contains("open")) {
        menu.style.opacity = 0;
        setTimeout(function () {
          menu.classList.remove("open");
        }, 250);
      } else {
        menu.classList.add("open");
        setTimeout(function () {
          menu.style.opacity = 1;
        }, 10);
      }
    });
  });

/* Yehor additions - simple system to determine if the user is logged in or not. */
const waitForElement = (selector) => {
  return new Promise((resolve) => {
    const loopDelay = 100; //ms
    const loop = () => {
      const element = document.querySelector(selector);

      if (element) return resolve(element);

      setTimeout(loop, loopDelay);
    };

    loop();
  });
};

const setCustomerIdCookie = (value) => {
  document.cookie = `shopifyCustomerId=${
    value ? value : "none"
  };path=/;domain=dstnc.com`;
};

const addClickListenerToLogoutButton = async () => {
  const logoutButton = await waitForElement(`[aria-label="Logout"]`);

  logoutButton.addEventListener("click", () => {
    setCustomerIdCookie("none");
  });
};

setCustomerIdCookie(ShopifyAnalytics?.meta.page.customerId);
addClickListenerToLogoutButton();
